// extracted by css-extract-rspack-plugin
export default {"tabPanel":"_47b149af"};